import styled from "styled-components";
import SilverBar from "../common/assets/silver_bar_shadow.png";
import UserTestimonial from "../component/user-testimonial";
import Customer0 from "../common/assets/customer0.jpeg"
import Customer1 from "../common/assets/customer1.jpeg"
import Customer2 from "../common/assets/customer2.jpeg"
import 'react-slideshow-image/dist/styles.css';
import { Slide } from "react-slideshow-image";
import { useEffect, useState } from "react";
import WhyAinBhawani from "../component/why-ainbhawani";

const AboutUsWrapper = styled.div`
    .title{
        width:24vw;
        margin: 0;
        font-size: 2.5rem;
        font-weight: 600;
        color: #053050;
        min-width: 300px;
        display: flex;
        justify-content: right;
    } 
    padding: 0 8vw;
    padding-top: 10vh;
    #intro{
        display: flex;
        align-items: center;
        justify-content: space-around;
        @media screen and (max-width: 600px){
            flex-direction: column;
            gap: 2vh;
            p{
                width: 80% !important;
            }
        }
            img{
                height: 333px;
                @media screen and (max-width: 800px){
                   width: 40vw;
                   height: auto;
                }
            }
                
            p{
                width: 45%;
                text-align: center;
                line-height: 1.5;
            }
        
   }

   #customer-testimonial{
    width: 84vw;
    margin-top: 4vh;
    display: flex;
    align-items: center;
    justify-content: space-around;
    @media screen and (max-width: 600px){
            flex-direction: column;
        }
   }

   #user-testimonials{
    width: 45%;
    @media screen and (max-width: 600px){
            width: 80%;
            display:flex;
            flex-direction: column;
            gap: 0vh;
            align-items: center;
        }
   }

   .each-slide-effect {
    height: 400px;
    width: 100%;
    display: flex;
    align-items: center;
    @media screen and (min-width: 600px){
        height: 400px;
        align-items: center;
        justify-content: center;
        background-size: cover;
    }
    }
`

const AboutUs = () => {
    const userMessages = [
        {
            message: `We are very pleased with AinBhawani’s timely delivery and transparent communication. Every gram of silver meets the highest standards.`,
            image: Customer0,
            name: "Rishikesh Khakurel"
        },
        {
            message: `Working with AinBhawani has been a smooth experience. Competitive prices, reliable service, and genuine care for customers make them stand out.`,
            image: Customer1,
            name: "Madhav Kumar Gupta"
        },
        {
            message: `Exceptional support and premium quality silver. We truly value our partnership with AinBhawani.`,
            image: Customer2,
            name: "Akash Shrestha"
        }
    ];

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <AboutUsWrapper>
            <div id="intro">
                <img src={SilverBar} alt="silver bar" />
                <p>
                    AinBhawani is a trusted name in the silver industry, committed to delivering premium raw silver to businesses and artisans across the region. With a focus on quality, reliability, and excellence, we provide raw silver that meets the highest industry standards.
                    Our dedication to transparency and customer satisfaction has made us a preferred choice for jewelers, manufacturers, and wholesalers looking for pure and consistent silver supply. At AinBhawani, we don’t just supply silver we deliver a promise of excellence in every gram.
                </p>
            </div>
            <div>
                <WhyAinBhawani/>
            </div>
            <div id="customer-testimonial">
                <div className="title">
                    <p >
                        What our <br />Customers are<br /> Saying
                    </p>
                </div>
                <div id="user-testimonials">
                    <Slide duration={2000} indicators={true} arrows={false} easing="ease" vertical={width < 600 ? true : false} infinite={true} autoplay={true} pauseOnHover={true} canSwipe={true}>
                        {userMessages.map((userMessage) =>
                            <div className="each-slide-effect">
                                <UserTestimonial message={userMessage.message} name={userMessage.name} image={userMessage.image} />
                            </div>
                        )}
                    </Slide>
                </div>
            </div>
        </AboutUsWrapper>
    )
}

export default AboutUs;